export default __webpack_public_path__ + "static/media/Hero2.6bb4e827.jpeg";